import { Component } from '@angular/core'
import { UserAccountService } from '@spartacus/user/account/core'

@Component({
  selector: 'mb-mpup-header',
  templateUrl: './mpup-header.component.html',
  styleUrls: ['./mpup-header.component.scss']
})
export class MpupHeaderComponent {

  constructor (private userAccountService: UserAccountService) { }

  getUserAccount () {
    return this.userAccountService.get()
  }
}
